$(document).ready(function() {
  function openMeetingModal() {
    const profileComponent = $('.clients-momentum-profile-component');
    if (profileComponent.length > 0) {
      profileComponent.find('.modal').modal('show');
    } else {
      alert('Meeting modal not found on this page.');
    }
  }

  $(document).on('click', '.clients-momentum-profile-component .meeting-links-btn', function() {
    openMeetingModal();
  });

  // Temporary solution for the Add meetings component-- Eventually will be leaning into an Outlook integration
  $(document).on('click', '.clients-meetings-add-component .add-meeting-link', function() {
    openMeetingModal();
  });
});